import Modbus from "./modbus.js";
import Bottleneck from "bottleneck";

class ModbusWithScheduler extends Modbus {
  constructor(...args) {
    super(...args);

    this.limiter = new Bottleneck({
      maxConcurrent: 1,
      minTime: 10
    });    
  }
  readHoldingRegisters(...args) {
    var super_readHoldingRegisters = super.readHoldingRegisters.bind(this, ...args);
    return this.limiter.schedule(async function() {
      return await super_readHoldingRegisters();
    });    
  }
  presetMultipleRegisters(...args) {
    var super_presetMultipleRegisters = super.presetMultipleRegisters.bind(this, ...args);
    return this.limiter.schedule(async function() {
      return await super_presetMultipleRegisters();
    });    
  }
}

export default ModbusWithScheduler;